import styled from 'styled-components';

const flexColumnStretch = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    align-items: stretch;
`;

export const GDLiveAppContentWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    width: 100%;
    text-align: center;
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: var(--gameday-live-background-color);
`;

export const FlexMainWrapper = styled.div`
    width: 100%;
    margin: 0;
    padding: 0;
    display: inline-block;
    margin-left: -50%;
    margin-right: -50%;
    margin-left: auto;
    margin-right: auto;
    min-width: var(--gameday-scaffold-flexMain-min-width);
    text-align: center;
    overflow: hidden;
    word-spacing: -5px;
    min-width: 100%;
`;

export const AppColumnWrapper = styled(flexColumnStretch)`
    width: 100%;
    max-width: 1920px;
    position: relative;
    white-space: normal;
    overflow: hidden;
    margin: 0 auto;
    height: 100%;
    min-height: calc(100svh - var(--safe-area-inset-bottom));
    padding: 0;
    vertical-align: top;
    text-align: left;
    word-spacing: 0px;

    @media only screen and (max-width: 1280px) {
        width:100%;
    }
`;

export const GDAppWrapper = styled(flexColumnStretch)`
    flex: 1 1 100%;
    position: relative;
`;
